// extracted by mini-css-extract-plugin
export default {"selectContainer":"Team_selectContainer__KY61f","teamSelect":"Team_teamSelect__iJPoT"};